import { gql } from "@apollo/client";

export default gql`
  mutation SetGroupResources($id: ObjectId!, $resources: [ResourceInput!]!) {
    setGroupResources(id: $id, resources: $resources) {
      _id
      resources {
        ... on LinkResource {
          url
          title
          addedAt
          type
        }
        ... on DownloadResource {
          url
          title
          filename
          addedAt
          type
        }
        ... on TextResource {
          title
          body
          addedAt
          type
        }
      }
    }
  }
`;
